import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { MAXIMUM_NUMBER_OF_RECOMMEND_PRODUCT_ITEM_COUNT } from '../../../../constants/service/app/recommendProductConstants';
import { RECOMMEND_PRODUCT_LIST_URL_PATH } from '../../../../constants/service/common/urlConstants';
import recommendProductToastMsg from '../../../../constants/service/toastMsg/recommendProductToastMsg';
import RecommendProductApi from '../../../../lib/api/recommend/product/RecommendProductApi';
import {
  _setResponseListForm,
  asyncSimpleModal,
  reDirectPage,
  setMultipartForm,
  setRequestForm,
} from '../../../../lib/common';
import toastMsg from '../../../../lib/toastMsg';
import noticeExcelDownloadResult from '../../../../lib/noticeExcelDownloadResult';
import { recommendProductActions } from './index';

function* fetchList() {
  /**
   *   추천 상품 리스트 가져오기
   */
  yield takeEvery(recommendProductActions.GET_RECOMMEND_PRODUCT_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendProductApi.getRecommendProductList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendProductToastMsg.GET_RECOMMEND_PRODUCT_LIST_REQUEST_SUCCESS);

        const data = {
          recommendProductList: _setResponseListForm(result.data.recommendProductList, result.data.totalCnt, payload),
        };

        yield put({
          type: recommendProductActions.GET_RECOMMEND_PRODUCT_LIST_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      toastMsg.error(recommendProductToastMsg.GET_RECOMMEND_PRODUCT_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 상품 상세 요청하기
   */
  yield takeEvery(recommendProductActions.GET_RECOMMEND_PRODUCT_DETAIL_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendProductApi.getRecommendProductDetail, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendProductToastMsg.GET_RECOMMEND_PRODUCT_DETAIL_REQUEST_SUCCESS);

        const data = {
          recommendProductDetail: {
            recommendProductInfo: result.data.recommendProductInfo,
            recommendProductItemList: result.data.recommendProductItemList,
            totalCnt: result.data.totalCnt,
          },
        };

        yield put({
          type: recommendProductActions.GET_RECOMMEND_PRODUCT_DETAIL_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      toastMsg.error(recommendProductToastMsg.GET_RECOMMEND_PRODUCT_DETAIL_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 상품 상세 EXCEL 다운로드
   */
  yield takeEvery(
    recommendProductActions.GET_RECOMMEND_PRODUCT_DETAIL_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST,
    function* ({ payload }) {
      try {
        const result = yield call(
          RecommendProductApi.getRecommendProductDetailItemListExcelDownload,
          setRequestForm(payload, true),
        );
        if (result.msg) {
          toastMsg.error(result.msg);
        } else {
          yield asyncSimpleModal({
            type: 'success',
            title: '엑셀 파일 요청 완료',
            message: `엑셀 파일이 생성되면 #amondz_admin_excel 슬랙 채널을 통해 다운로드 링크가 담긴 메시지가 전송됩니다 슬랙을 확인해주세요`,
          });
        }
      } catch (error) {
        toastMsg.error(
          error.message || recommendProductToastMsg.GET_RECOMMEND_PRODUCT_DETAIL_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR,
        );
      }
    },
  );

  /**
   *   추천 상품 복사하기 전 필요한 데이터 가져오기
   */
  yield takeEvery(recommendProductActions.PREPARE_COPY_RECOMMEND_PRODUCT_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendProductApi.prepareCopyRecommendProduct, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendProductToastMsg.PREPARE_COPY_RECOMMEND_PRODUCT_REQUEST_SUCCESS);

        const data = {
          recommendProductSave: {
            recommendProductInfo: result.data.recommendProductInfo,
            selectedRecommendProductItemList: result.data.selectedRecommendProductItemList,
            recommendProductItemList: _setResponseListForm(
              result.data.recommendProductItemList.list,
              result.data.recommendProductItemList.totalCnt,
              payload,
            ),
          },
          mainProductCategorySelectList: result.data.mainProductCategorySelectList,
          subProductCategorySelectList: result.data.subProductCategorySelectList,
        };

        yield put({
          type: recommendProductActions.PREPARE_COPY_RECOMMEND_PRODUCT_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      toastMsg.error(recommendProductToastMsg.PREPARE_COPY_RECOMMEND_PRODUCT_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 상품 등록하기 전 필요한 데이터 가져오기
   */
  yield takeEvery(recommendProductActions.PREPARE_CREATE_RECOMMEND_PRODUCT_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendProductApi.prepareCreateRecommendProduct, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendProductToastMsg.PREPARE_CREATE_RECOMMEND_PRODUCT_REQUEST_SUCCESS);

        const data = {
          recommendProductSave: {
            recommendProductItemList: _setResponseListForm(
              result.data.recommendProductItemList.list,
              result.data.recommendProductItemList.totalCnt,
              payload,
            ),
          },
          mainProductCategorySelectList: result.data.mainProductCategorySelectList,
          subProductCategorySelectList: result.data.subProductCategorySelectList,
        };

        yield put({
          type: recommendProductActions.PREPARE_CREATE_RECOMMEND_PRODUCT_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      toastMsg.error(recommendProductToastMsg.PREPARE_CREATE_RECOMMEND_PRODUCT_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 상품에 연결할 아이템 리스트 요청하기
   */
  yield takeEvery(recommendProductActions.GET_RECOMMEND_PRODUCT_ITEM_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendProductApi.getRecommendProductItemList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendProductToastMsg.GET_RECOMMEND_PRODUCT_ITEM_REQUEST_SUCCESS);

        const data = {
          recommendProductItemList: _setResponseListForm(
            result.data.recommendProductItemList.list,
            result.data.recommendProductItemList.totalCnt,
            payload,
          ),
        };

        yield put({
          type: recommendProductActions.GET_RECOMMEND_PRODUCT_ITEM_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      toastMsg.error(recommendProductToastMsg.GET_RECOMMEND_PRODUCT_ITEM_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 상품 등록/복사하기
   */
  yield takeEvery(recommendProductActions.CREATE_RECOMMEND_PRODUCT_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendProductApi.createRecommendProduct, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendProductToastMsg.CREATE_RECOMMEND_PRODUCT_REQUEST_SUCCESS);

        reDirectPage({ path: RECOMMEND_PRODUCT_LIST_URL_PATH });
      }
    } catch (error) {
      toastMsg.error(recommendProductToastMsg.CREATE_RECOMMEND_PRODUCT_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 상품 등록하기 엑셀 파일업로드
   */
  yield takeEvery(recommendProductActions.CREATE_RECOMMEND_PRODUCT_BY_EXCEL_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendProductApi.createRecommendProductByExcel, setMultipartForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        yield asyncSimpleModal({
          type: 'success',
          title: recommendProductToastMsg.CREATE_RECOMMEND_PRODUCT_REQUEST_SUCCESS,
          message: `해당 작업이 완료되기까지 수분의 시간이 소요됩니다. 완료시 #amondz_admin 슬랙 채널을 통해 업데이트 결과가 전송됩니다. 슬랙을 확인해주세요.`,
        });

        reDirectPage({ path: RECOMMEND_PRODUCT_LIST_URL_PATH });
      }
    } catch (error) {
      toastMsg.error(recommendProductToastMsg.CREATE_RECOMMEND_PRODUCT_REQUEST_ERROR, error);
    }
  });

  /**
   *   전체 상품 리스트 EXCEL 다운로드
   */
  yield takeEvery(
    recommendProductActions.GET_RECOMMEND_PRODUCT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST,
    function* ({ payload }) {
      try {
        const result = yield call(
          RecommendProductApi.getRecommendProductItemListExcelDownload,
          setRequestForm(payload, true),
        );
        noticeExcelDownloadResult(payload.email, result.msg);
      } catch (error) {
        toastMsg.error(
          error.message || recommendProductToastMsg.GET_RECOMMEND_PRODUCT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR,
          error,
        );
      }
    },
  );

  /**
   *   선택된 상품 리스트 EXCEL 다운로드
   */
  yield takeEvery(
    recommendProductActions.GET_SELECTED_RECOMMEND_PRODUCT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST,
    function* ({ payload }) {
      try {
        const result = yield call(
          RecommendProductApi.getSelectedRecommendProductItemListExcelDownload,
          setRequestForm(payload, true),
        );
        noticeExcelDownloadResult(payload.email, result.msg);
      } catch (error) {
        toastMsg.error(
          error.message ||
            recommendProductToastMsg.GET_SELECTED_RECOMMEND_PRODUCT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR,
          error,
        );
      }
    },
  );

  /**
   *  상품 리스트 EXCEL 업로드
   */
  yield takeEvery(
    recommendProductActions.SET_RECOMMEND_PRODUCT_ITEM_LIST_EXCEL_UPLOAD_REQUEST,
    function* ({ payload }) {
      try {
        const result = yield call(
          RecommendProductApi.setRecommendProductItemListExcelUpload,
          setMultipartForm(payload, true),
        );
        if (result.msg) {
          toastMsg.error(result.msg);
        } else {
          toastMsg.success(recommendProductToastMsg.SET_RECOMMEND_PRODUCT_ITEM_LIST_EXCEL_UPLOAD_REQUEST_SUCCESS);

          /**
           *  추가하려고 하는 추천 상품 아이템 개수가 초가되었을 경우
           *  업로드를 하지 못하도록 함
           */
          if (result.data.totalCnt > MAXIMUM_NUMBER_OF_RECOMMEND_PRODUCT_ITEM_COUNT[payload.recommendProductType]) {
            yield asyncSimpleModal({
              type: 'error',
              title: '아이템 개수 초과',
              message: `추천 상품 아이템 개수는 최대 ${
                MAXIMUM_NUMBER_OF_RECOMMEND_PRODUCT_ITEM_COUNT[payload.recommendProductType]
              } 입니다.`,
            });
            return;
          }

          yield put({
            type: recommendProductActions.SET_RECOMMEND_PRODUCT_ITEM_LIST_EXCEL_UPLOAD_SUCCESS,
            payload: result.data,
          });
        }
      } catch (error) {
        toastMsg.error(
          error.message || recommendProductToastMsg.SET_RECOMMEND_PRODUCT_ITEM_LIST_EXCEL_UPLOAD_REQUEST_ERROR,
          error,
        );
      }
    },
  );
}

export default function* widgetSaga() {
  yield fork(fetchList);
}
